import React, { useState } from "react";
import PropTypes from "prop-types";

const FileSelector = ({ onChange }) => {
  const [files, setFiles] = useState([]);

  const handleChange = event => {
    const filesArr = Array.prototype.slice.call(event.target.files);
    setFiles(filesArr);
    onChange?.(event);
  };

  const removeFile = () => {};

  return (
    <>
      <div className="file-upload btn btn-outline-primary">
        Chọn file
        <input type="file" accept="image/*" onChange={handleChange} />
      </div>
      {files.map((file, index) => (
        <div
          key={index}
          className="file-preview"
          onClick={() => removeFile(file)}
        >
          {file.name}
        </div>
      ))}
    </>
  );
};

FileSelector.propTypes = {
  onChange: PropTypes.func,
};

export default FileSelector;
